export default function PageEdgeLines({ side }) {
  const isLeft = side === 'left';
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        top: 0,
        bottom: 0,
        [isLeft ? 'left' : 'right']: 0,
        width: 28,
        pointerEvents: 'none',
        zIndex: 0,
        overflow: 'hidden',
        display: 'var(--page-edge-display, block)',
      }}
    >
      <svg
        width="28"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
        style={{ color: 'var(--grid-line)', opacity: 0.8 }}
      >
        {isLeft ? (
          <>
            <line x1="14" y1="0" x2="14" y2="100%" stroke="currentColor" strokeWidth="0.5" opacity="0.9" />
            <line x1="22" y1="0" x2="22" y2="100%" stroke="currentColor" strokeWidth="0.35" opacity="0.5" />
            <line x1="14" y1="33%" x2="28" y2="33%" stroke="currentColor" strokeWidth="0.6" opacity="0.7" />
            <line x1="0" y1="33%" x2="8" y2="33%" stroke="currentColor" strokeWidth="0.5" opacity="0.5" />
            <line x1="14" y1="66%" x2="28" y2="66%" stroke="currentColor" strokeWidth="0.6" opacity="0.7" />
            <line x1="0" y1="66%" x2="8" y2="66%" stroke="currentColor" strokeWidth="0.5" opacity="0.5" />
            <circle cx="14" cy="33%" r="1.5" fill="none" stroke="currentColor" strokeWidth="0.5" opacity="0.6" />
            <circle cx="14" cy="66%" r="1.5" fill="none" stroke="currentColor" strokeWidth="0.5" opacity="0.6" />
          </>
        ) : (
          <>
            <line x1="14" y1="0" x2="14" y2="100%" stroke="currentColor" strokeWidth="0.5" opacity="0.9" />
            <line x1="6" y1="0" x2="6" y2="100%" stroke="currentColor" strokeWidth="0.35" opacity="0.5" />
            <line x1="0" y1="33%" x2="14" y2="33%" stroke="currentColor" strokeWidth="0.6" opacity="0.7" />
            <line x1="20" y1="33%" x2="28" y2="33%" stroke="currentColor" strokeWidth="0.5" opacity="0.5" />
            <line x1="0" y1="66%" x2="14" y2="66%" stroke="currentColor" strokeWidth="0.6" opacity="0.7" />
            <line x1="20" y1="66%" x2="28" y2="66%" stroke="currentColor" strokeWidth="0.5" opacity="0.5" />
            <circle cx="14" cy="33%" r="1.5" fill="none" stroke="currentColor" strokeWidth="0.5" opacity="0.6" />
            <circle cx="14" cy="66%" r="1.5" fill="none" stroke="currentColor" strokeWidth="0.5" opacity="0.6" />
          </>
        )}
      </svg>
    </div>
  );
}
